import React, { useEffect, useState } from "react";
import "../assets/styles/contatti.css";
import ContattiComponentsMob from "../components/ContattiComponents-mob";
import NavbarComponent from "../components/Navbar-component";
import { useTranslation } from "react-i18next";

const Contatti = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { t } = useTranslation();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="contatti-page">
      {/* Hero with background image so navbar is visible */}
      <div className="contatti-hero">
        <div className="contatti-hero-overlay" />
        <div className="contatti-hero-nav">
          <NavbarComponent />
        </div>
        <div className="contatti-hero-content">
          <span className="contatti-eyebrow">{t('contatti.hero.eyebrow')}</span>
          <h1 className="contatti-title">{t('contatti.hero.title')}</h1>
          <p className="contatti-subtitle">
            {t('contatti.hero.subtitle')}
          </p>
        </div>
      </div>

      {/* Contact card */}
      <div className="contatti-body">
        <ContattiComponentsMob />
      </div>
    </div>
  );
};

export default Contatti;
